module.exports = __webpack_public_path__ + "media/images/woman-tip-47383faee37f51fb780b1ab24ba7583a.svg";